package com.htmlagent.site.components.widgets

import kotlin.js.Promise

/**
 * Copying to the clipboard, which Kotlin/JS does not expose on `Navigator`.
 *
 * It is declared here rather than reached for with `js(...)` at the call site so the failure
 * path is a value and not an exception: the API rejects when the page is not focused or the
 * browser refuses, and the caller has to keep its label honest either way.
 */
private external val navigator: NavigatorWithClipboard

private external interface NavigatorWithClipboard {
    val clipboard: Clipboard?
}

private external interface Clipboard {
    fun writeText(text: String): Promise<Unit>
}

/** Copies [text] and reports whether it actually made it. */
fun copyToClipboard(text: String, onResult: (Boolean) -> Unit) {
    val clipboard = navigator.clipboard
    if (clipboard == null) {
        onResult(false)
        return
    }
    clipboard.writeText(text)
        .then { onResult(true) }
        .catch { onResult(false) }
}
